export default __webpack_public_path__ + "static/media/cloud.d1ac4917.svg";